const config = {
  rowSelection: false,
  columns: [
    {
      title: '客户编号',
      width: 190,
      dataIndex: 'id',
      render: 'numberRender',
      fixed: 'left',
    },
    // {
    //   title: 'JDPIN',
    //   dataIndex: 'pin',
    //   width: 190,
    //   render: (text: string) => {
    //     return text ? text : '-'
    //   },
    // },
    {
      title: '客户名称',
      dataIndex: 'name',
      width: 100,
    },
    {
      title: '客户电话',
      dataIndex: 'phone',
      width: 130,
      render: 'checkPhoneRender',
    },
    {
      title: '所属门店',
      dataIndex: 'orgNames',
      width: 150,
      render: 'orgNamesRender',
    },
    {
      title: '最近更新时间',
      dataIndex: 'lastUpdatedTime',
      width: 150,
      itemType: 'dateTime',
    },
    {
      title: '客户创建时间',
      dataIndex: 'createdTime',
      width: 150,
      itemType: 'dateTime',
    },
    {
      title: '操作',
      width: 150,
      fixed: 'right',
      render: 'actionTool',
    },
  ],
  search: [
    {
      name: 'nameLike',
      label: '客户名称',
    },
    {
      name: 'id',
      label: '客户编号',
    },
    {
      name: 'phone',
      label: '客户电话',
    },
    {
      name: 'storeIds',
      label: '所属门店',
      itemType: 'select',
      data: 'companyList',
      labelKey: 'name',
      key: 'id',
    },
    {
      name: 'pin',
      label: 'JDPIN',
    },
  ],
  footer: [{ render: 'createCustomer' }],
}

export default config
